import { Form } from "react-bootstrap";

import { FormControlWrapper } from "./formControlWrapper";
import { getDropdownValue } from "..";

export const FieldDropdown = ({
	isDisabled,
	// TODO: understand how to make this better
	isForced = false,
	error,
	fieldData,
	isMandatory,
	dropdownData = [],
	placeholder = "",
	title = "",
	autoFocus,
	tooltip,
	setValue = console.log,
}) => {
	const defVal = getDropdownValue({
		isMandatory,
		dropdownData,
		valueToFind: fieldData,
	});

	return (
		<FormControlWrapper
			title={title}
			tooltip={tooltip}
			data-testid="test-fieldDropdown"
			error={error}
		>
			<Form.Select
				data-testid="test-fieldDropdownControl"
				onChange={(e) => setValue(e.target.value)}
				isInvalid={!!error}
				disabled={isDisabled}
				// TODO: move to utils
				value={isForced ? defVal : undefined}
				defaultValue={defVal}
				autoFocus={autoFocus}
			>
				{!isMandatory ? (
					<option value={-1}>{placeholder}</option>
				) : null}
				{dropdownData?.map(({ id, label }, index) => (
					<option key={index} value={id}>
						{label}
					</option>
				))}
			</Form.Select>
		</FormControlWrapper>
	);
};
